import React from 'react';

import { trans } from '@spotahome/soyuz/client';
import { Heading } from '@spotahome/ui-library';

import './WhyJoin.scss';

const WhyJoin = () => (
  <div className="wrapper">
    <Heading
      size="large"
      text={trans('ambassador.why-join.title')}
      className="mb-xl"
    />

    <div className="why-join">
      <ol className="why-join__list">
        <li className="why-join__list-item">
          {trans('ambassador.why-join.item.first')}
        </li>
        <li className="why-join__list-item">
          {trans('ambassador.why-join.item.second')}
        </li>
        <li className="why-join__list-item">
          {trans('ambassador.why-join.item.third')}
        </li>
        <li className="why-join__list-item">
          {trans('ambassador.why-join.item.fourth')}
        </li>
        <li className="why-join__list-item">
          {trans('ambassador.why-join.item.fifth')}
        </li>
      </ol>
    </div>
  </div>
);

export default WhyJoin;
